export default __webpack_public_path__ + "static/opt-grad-left-1113da9923848d6fd838dc98f56e8af6.svg";